import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
const section = document.querySelector('.social-feed__section');

export const initSocialFeedScript = () => {
  if (!section) return;
  const sliders = section?.querySelectorAll('.social-feed__container');
  if (!sliders) return;
  sliders?.forEach((slider) => {
    const swiperOptions = {
      slidesPerView: 'auto',
      loop: false,
      breakpoints: {
        375: {
          slidesPerView: 1.37866,
          spaceBetween: 16,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 28,
          centeredSlides: true,
          initialSlide: 2,
        },
        1280: {
          slidesPerView: 4.3555,
          spaceBetween: 32,
          centeredSlides: true,
          initialSlide: 2,
        },
      },
    };
    new Swiper(slider, swiperOptions);
  });

  const videos = section?.querySelectorAll(
    '.social-feed__video-container video',
  );

  section.querySelectorAll('.social-feed__play-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const videoContainer = btn.closest('.social-feed__video-container');
      const video = videoContainer.querySelector('video');

      videos.forEach((videoElement) => {
        if (videoElement !== video) {
          videoElement.pause();
          videoElement
            .closest('.social-feed__video-container')
            .classList.remove('playing');
        }
      });

      if (video.paused) {
        video.play();
        videoContainer.classList.add('playing');
      }
    });
  });

  section.querySelectorAll('.social-feed__pause-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const videoContainer = btn.closest('.social-feed__video-container');
      const video = videoContainer.querySelector('video');

      if (!video.paused) {
        video.pause();
        videoContainer.classList.remove('playing');
      }
    });
  });

  videos?.forEach((video) => {
    video.addEventListener('ended', function () {
      const videoContainer = this.closest('.social-feed__video-container');
      videoContainer.classList.remove('playing');
    });
  });
};
